'use client';

import EmblaCarousel from '@/components/EmblaCarousel';
import { useIsMobile } from '@/hooks/useIsMobile';
import Image from 'next/image';
export const OurValues = () => {
  const slides = [
    {
      image: '/about-us/durable.png',
      icon: '/about-us/durable-icon.png',
      title: 'Durable',
      description: 'Built to last through the toughest environments.',
    },
    {
      image: '/about-us/comfortable.png',
      icon: '/about-us/comfortable-icon.png',
      title: 'Comfortable',
      description: 'Designed with comfort in mind, so you can focus on your adventure.',
    },
    {
      image: '/about-us/sustainable.png',
      icon: '/about-us/sustainable-icon.png',
      title: 'Sustainable',
      description: 'Eco-friendly materials reflect our commitment to protecting the planet.',
    },
  ];
  const OPTIONS = {
    containScroll: false,
    align: 'start',
  };
  const { isMobile } = useIsMobile();
  return (
    <div className='w-full px-[12px] py-[40px] text-center lg_px-0 lg_py-[80px]'>
      <div className='container mx-auto '>
        <h2 className='mb-[10px] text-left font-teko-medium text-[28px] uppercase leading-[28px] text-primary lg_mb-0 lg_text-[40px] lg_leading-[48px]'>
          Our Values
        </h2>

        <p className='mb-[20px] text-left font-roboto-regular text-[16px] leading-[24px] text-primary lg_mb-[40px] lg_leading-[30px]'>
          At the heart of Hisea is a dedication to quality, innovation, and sustainability. We believe that outdoor gear
          should be:
        </p>

        <div className='mt-[20px] w-full'>
          <EmblaCarousel
            slides={slides}
            options={OPTIONS}
            classes={{
              emblaSlide: 'flex-[0_0_300px] lg_mr-[45px] mr-[20px] lg_flex-[0_0_450px]',
              emblaControls: 'hidden',
            }}
          >
            {(item, index) => (
              <div
                key={index}
                className=''
              >
                <div className='relative'>
                  <Image
                    src={`${item.image}?v=1.2`}
                    alt='about-us-new-page'
                    width={450}
                    height={450}
                  />
                </div>
                <div className='flex items-start justify-between pt-[10px] lg_pt-[20px]'>
                  <Image
                    className='h-[50px] w-[50px] lg_h-[80px] lg_w-[80px]'
                    src={`${item.icon}?v=1.2`}
                    alt='about-us-new-page'
                    width={isMobile ? 50 : 80}
                    height={isMobile ? 50 : 80}
                  />
                  <div className='pl-[10px] text-left lg_pl-[26px]'>
                    <h3 className='text-medium mb-[5px] font-roboto-medium text-[18px] leading-[21px] lg_mb-[10px] lg_text-[22px] lg_leading-[26px]'>
                      {item.title}
                    </h3>
                    <p className='text-normal font-roboto-regular text-[16px] leading-[24px] lg_text-[18px] lg_leading-[30px] '>
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </EmblaCarousel>
          {/* {[].map((item, index) => (
            <div
              key={index}
              className='bg-[#f8f8f8]'
            >
              <div className='relative'>
                <Image
                  src={`${item.image}?v=1.2`}
                  alt='about-us-new-page'
                  width={450}
                  height={450}
                />
                <Image
                  className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2'
                  src={`${item.icon}?v=1.2`}
                  alt='about-us-new-page'
                  width={130}
                  height={130}
                />
              </div>
              <h3 className='mt-[64px] font-oswald-bold text-[28px] text-primary'>{item.title}</h3>
              <p className='mt-[12px] px-[30px] pb-[30px] font-urw-din-medium text-primary'>{item.description}</p>
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
};
